import React, { FC } from 'react'
import styled from 'styled-components'

export interface ItemImagePreviewProps {
  className?: string
  alt: string
  src: string
  selected?: boolean
  onImageSelected: (src: string) => void
}

const ItemImagePreview: FC<ItemImagePreviewProps> = ({
  alt,
  className,
  src,
  selected = false,
  onImageSelected,
}) => (
  <img
    alt={alt}
    className={`${className} ${selected ? 'selected' : ''}`}
    src={src}
    onClick={() => onImageSelected(src)}
  />
)

const StyledItemImagePreview = styled(ItemImagePreview)(({ theme }) => {
  const basePreviewImageSize = 45

  return {
    border: '2px solid transparent',
    borderRadius: '4px',
    height: `${basePreviewImageSize}px`,
    marginRight: '8px',
    objectFit: 'contain',
    width: `${basePreviewImageSize}px`,
    '&:hover': {
      cursor: 'pointer',
    },
    '&:last-of-type': {
      marginRight: 0,
    },
    '&.selected, &:hover': {
      border: `2px solid ${theme.colors.brand.blue}`,
    },

    '@media(min-width: 600px)': {
      marginBottom: '8px',
      marginRight: 0,
      '&:last-of-type': {
        marginBottom: 0,
      },
    },
  }
})

export default StyledItemImagePreview
